module.exports = __webpack_public_path__ + "img/2.b423d233.jpg";